import React, { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { GripVertical } from "lucide-react";

export const Handle = forwardRef<HTMLButtonElement>((props, ref) => {
  return (
    <Button
      ref={ref}
      type="button"
      className="cursor-grab"
      variant={"ghost"}
      {...props}
    >
      <GripVertical className="text-foreground" />
    </Button>
  );
});
